import { AbstractControl, ValidationErrors, Validators } from '@angular/forms';

export function emailValidator(
  control: AbstractControl
): ValidationErrors | null {
  const value = control.value;
  if (!value || typeof value !== 'string') {
    return null;
  }

  // Stricter requirements
  if (
    value.length > 256 ||
    value.indexOf('@') === -1 ||
    value.indexOf('@') !== value.lastIndexOf('@') ||
    value.indexOf('.', value.indexOf('@')) === -1 ||
    /[^A-Za-z0-9@._-]/.test(value)
  ) {
    return { invalidEmail: true };
  }

  // Use Angular's built-in email validator
  return Validators.email(control) ? { invalidEmail: true } : null;
}